// extracted by mini-css-extract-plugin
export default {"container":"style_container__EOQBK","text_404":"style_text_404__9IUVO"};